/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ActivationFunnelE4Breakdown interface.
 */
export function instanceOfActivationFunnelE4Breakdown(value) {
    if (!('firstAiGenerationCompleted' in value) || value['firstAiGenerationCompleted'] === undefined)
        return false;
    if (!('firstPanelOpened' in value) || value['firstPanelOpened'] === undefined)
        return false;
    if (!('firstRecordingStarted' in value) || value['firstRecordingStarted'] === undefined)
        return false;
    if (!('micPermissionGranted' in value) || value['micPermissionGranted'] === undefined)
        return false;
    return true;
}
export function ActivationFunnelE4BreakdownFromJSON(json) {
    return ActivationFunnelE4BreakdownFromJSONTyped(json, false);
}
export function ActivationFunnelE4BreakdownFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstAiGenerationCompleted': json['firstAiGenerationCompleted'],
        'firstPanelOpened': json['firstPanelOpened'],
        'firstRecordingStarted': json['firstRecordingStarted'],
        'isLowerBound': json['isLowerBound'] == null ? undefined : json['isLowerBound'],
        'micPermissionGranted': json['micPermissionGranted'],
    };
}
export function ActivationFunnelE4BreakdownToJSON(json) {
    return ActivationFunnelE4BreakdownToJSONTyped(json, false);
}
export function ActivationFunnelE4BreakdownToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstAiGenerationCompleted': value['firstAiGenerationCompleted'],
        'firstPanelOpened': value['firstPanelOpened'],
        'firstRecordingStarted': value['firstRecordingStarted'],
        'isLowerBound': value['isLowerBound'],
        'micPermissionGranted': value['micPermissionGranted'],
    };
}
